import * as yup from 'yup';

import { Constants } from '@/constants';
import { localizableString } from '@/helpers/validation.helper';
import type { Locales } from '@/services/types/api.types';

export const formValidationSchema = (languageEnabled: Locales[]) =>
  yup.object({
    type: yup.number().required(),
    is_mandatory: yup.number().required(),
    question: yup.object().shape({
      title: localizableString(languageEnabled),
      image: yup
        .object()
        .shape({
          url: yup.string().optional(),
          altText: localizableString(languageEnabled, { optional: true }),
        })
        .nullable(),
    }),
    answers: yup.object().shape({
      steps: yup.array().of(
        yup.object().shape({
          answerId: yup.string().optional(),
          type: yup.string().required(),
          choices: yup
            .array()
            .of(
              yup.object().shape({
                id: yup.string().required(),
                text: localizableString(languageEnabled),
                order_num: yup.string().when('$type', {
                  is: (val: number) => val === Constants.Form.Type.Proposal,
                  then: (schema) => schema.optional(),
                  otherwise: (schema) => schema.required(),
                }),
              }),
            )
            .when('$type', {
              is: (val: number) => val === Constants.Form.Type.Question,
              then: (schema) =>
                schema
                  .required('validation.forms.multiple-choice.required')
                  .min(1, 'validation.forms.multiple-choice.required'),
              otherwise: (schema) => schema.optional(),
            }),
          level_choices: yup
            .array()
            .of(
              yup.object().shape({
                value: yup.string().required(),
                label: localizableString(languageEnabled),
              }),
            )
            .when('$type', {
              is: (val: number) => val === Constants.Form.Type.Matrix,
              then: (schema) =>
                schema
                  .required('validation.forms.slider.level-choices.required')
                  .min(1, 'validation.forms.slider.level-choices.required'),
              otherwise: (schema) => schema.optional(),
            }),
          levels: yup
            .array()
            .of(
              yup.object().shape({
                answerId: yup.string().required(),
                name: localizableString(languageEnabled),
                order_num: yup.string().when('$type', {
                  is: (val: number) => val === Constants.Form.Type.Proposal,
                  then: (schema) => schema.optional(),
                  otherwise: (schema) => schema.required(),
                }),
                type: yup.string().required(),
              }),
            )
            .when('$type', {
              is: (val: number) => val === Constants.Form.Type.Matrix,
              then: (schema) =>
                schema
                  .required('validation.forms.slider.levels.required')
                  .min(1, 'validation.forms.slider.levels.required'),
              otherwise: (schema) => schema.optional(),
            }),
          map: yup.object().when('$type', {
            is: (val: number) => val === Constants.Form.Type.Map,
            then: (schema) =>
              schema.shape({
                categories: yup
                  .array()
                  .required('validation.forms.map.categories.required')
                  .min(1, 'validation.forms.map.categories.required'),
              }),
            otherwise: (schema) => schema.optional(),
          }),
          dots: yup.array().when('$type', {
            is: (val: number) => val === Constants.Form.Type.DotVoting,
            then: (schema) =>
              schema
                .required('validation.forms.dot-voting.dots.min-two')
                .min(2, 'validation.forms.dot-voting.dots.min-two'),
            otherwise: (schema) => schema.optional(),
          }),
        }),
      ),
    }),
  });
